import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorManagerService } from 'src/app/services/error-manager.service';
import { TFAStatus, UserStatus, UserType } from 'src/app/enums/constants';

@Component({
    selector: 'app-two-factor-auth-modal',
    templateUrl: './two-factor-auth.component.html',
    styleUrls: ['./two-factor-auth.component.scss'],
    standalone: false
})
export class TwoFactorAuthComponent {
  loading: boolean;
  form = new FormGroup({
    token: new FormControl('', [Validators.minLength(3)])
  });
  verifyTokenErr: string;
  tokenWasSuccessfulySend: boolean;
  showTFATimer: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TwoFactorAuthComponent>,
    private userService: UserService,
    private authService: AuthService,
    public errorManager: ErrorManagerService,
  ) {}

  public checkAndSetClass(e) {
    const type = e.type;
    const target = e.target;
    const value = target.value;
    const parentElement = target.parentElement;

    if (value || type === 'focus') {
      parentElement ? parentElement.classList.add('inputted') : null;
    } else {
      parentElement ? parentElement.classList.remove('inputted') : null;
    }
  }

  public closeDialog() {
    this.dialogRef.close(null);
  }

  public showHideTFAInfo() {
    const tfaInvalidElement = document.querySelector('.tfa-invalid');
    const navbarHidden = document.querySelector('.navbar-hide');
    if(tfaInvalidElement){
      tfaInvalidElement.classList.remove('tfa-invalid');
    }
    if (navbarHidden && (this.userService.usertype === UserType.USER)) {
      navbarHidden.classList.remove('navbar-hide');
    }
  }

  public submit() {
    const self = this;
    const { token } = this.form.value;
    const params = {
      code: token,
    };
    self.verifyTokenErr = '';

    this.userService.verifyLoggedInUserTFA(params, {
      getResult(result) {
        if (result.data && !(result.data.status === TFAStatus.APPROVED)) {
          self.verifyTokenErr = self.errorManager.ERRORS.entered_code_invalid;
          self.userService.user.tfaSuccess = false;
        }
        if (result.data && result.data.status === TFAStatus.APPROVED) {
          self.userService.user.tfaSuccess = true;
          self.showHideTFAInfo();
          self.closeDialog();
        }
      },
      getError(err) {
        self.verifyTokenErr = self.errorManager.getMessage(err.error);
       if(err.error && err.error.userStatus){
          self.userService.user.status = err.error.userStatus;
          if(err.error.userStatus === UserStatus.LOCKED_INVALID_TFA) {
            self.authService.doLogout(true);
          }
        }
      },
    });
  }

  sendTFA() {
    const self = this;
    this.showTFATimer = true;
    setTimeout(() => {
      this.showTFATimer = false;
    }, 60000);
    this.userService.sendLoggedInUserTFA({
      getResult(result) {
        if (result.data.success) {
          self.tokenWasSuccessfulySend = true;
          setTimeout(() => {
            self.tokenWasSuccessfulySend = false;
          }, 1500);
        }
      },
      getError(err) {
        self.verifyTokenErr = self.errorManager.getMessage(err.error);
        if(err.error?.userStatus === UserStatus.LOCKED_INVALID_TFA) {
          self.authService.doLogout(true);
        }
      },
    });
  }
}
